import { PropertyService } from './../api/property.service';
import { AgencyService } from './../api/agency.service';
import { Component, OnInit, Injector, Inject, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Property } from './../models/index';
import { Lightbox, LightboxConfig, LightboxEvent, LIGHTBOX_EVENT, IAlbum } from 'angular2-lightbox';
import { Subscription } from 'rxjs/Subscription';
import { Image } from '../models/index';
import { DOCUMENT, DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { BaseComponent } from './base-component';
import { GoogleMapComponent } from '../gmaps/google-map/google-map.component';

@Component({
  selector: 'app-house-details-base',
  template: ''
})

export class HouseDetailsBaseComponent extends BaseComponent implements OnInit {
  @ViewChild(GoogleMapComponent) googleMap: GoogleMapComponent;
  property: Property;
  promoProperties: Property[];
  type: string = 'house';
  characteristics: string;
  public item: any;
  private _albums: IAlbum[];
  private _subscription: Subscription;

  _iframeSrc: SafeResourceUrl;
  get virtualTourIframeSrc(): SafeResourceUrl {
    if (this._iframeSrc)
      return this._iframeSrc;
    if (!this.property || !this.property.virtual_tour_url) {
      this._iframeSrc = null;
      return null;
    }

    this._iframeSrc = this.sanitizer.bypassSecurityTrustResourceUrl(this.property.virtual_tour_url);
    return this._iframeSrc;
  }

  constructor(
    injector: Injector,
    private sanitizer: DomSanitizer,
    public route: ActivatedRoute,
    public agencyService: AgencyService,
    public propertyService: PropertyService,
    private _lightbox: Lightbox,
    private _lightboxEvent: LightboxEvent,
    private _lighboxConfig: LightboxConfig,
    @Inject('WINDOW') public window: any,
    @Inject(DOCUMENT) public document: any
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.route.data.forEach((data: { property: Property }) => {
      if (data.property) {
        this.validateRouteDataParams(data, ['property']);
        this.property = data.property;

        this.item = data.property;
        this.item.latitude = this.property.website_latitude;
        this.item.longitude = this.property.website_longitude;

        this.characteristics = this.propertyService.generateCharacteristicsString(this.property);
        this.initLightbox(this.property.images);

        this.setTitle(
          this.property.title + (this.property.project && this.property.project.name ? ' - ' + this.property.project.name : '')
        );
        this.setMetaDescription(this.property.description);
      }
    });

    const promise = this.propertyService.getPromoProperties();

    if (promise) {
      promise.then(properties => {
        this.promoProperties = properties;
      });
    }
  }

  open(index: number): void {
    if (this.window) {
      this._lighboxConfig.positionFromTop = 0;
      this._lighboxConfig.centerVertically = true;
      this._lighboxConfig.fitImageInViewPort = true;
    }
    this._subscription = this._lightboxEvent.lightboxEvent$.subscribe(event => this._onReceivedEvent(event));
    this._lightbox.open(this._albums, index, { wrapAround: true, showImageNumberLabel: true });
  }

  private _onReceivedEvent(event: any): void {
    if (event.id === LIGHTBOX_EVENT.CLOSE) {

      if (this._subscription) {
        this._subscription.unsubscribe();
      }
    }
  }

  initLightbox(images: Image[]): void {
    this._albums = [];

    for (const image of images) {
      const album = {
          src: image.url,
          caption: image.description,
          thumb: image.width_560_url
      };

      this._albums.push(album);
    }

    this._lighboxConfig.fadeDuration = 1;
  }
}



// WEBPACK FOOTER //
// ./src/app/common-theme/base-components/house-details-base.component.ts